import type { HomeMarketingFeatureSlug } from "@/content/home-feature-modules";
import type { FeatureSlug } from "@/content/features";

/** Fixed shell height  -  both columns stretch to fill; tabs and preview share space evenly. */
export const HOME_FEATURE_SHOWCASE_GRID_HEIGHT_CLASS =
  "lg:h-[680px] lg:items-stretch";

/** Each sidebar tab gets an equal slice of the column (6 tabs). */
export const HOME_FEATURE_SHOWCASE_TAB_ROW_CLASS = "min-h-0 flex-1 basis-0";

/** Mobile uses explicit height; desktop grows to fill the column above the dot row. */
export const HOME_FEATURE_SHOWCASE_PREVIEW_VIEWPORT_CLASS =
  "h-[380px] shrink-0 overflow-hidden sm:h-[420px] lg:min-h-0 lg:flex-1";

/** Slides fill the viewport; chrome reset avoids double frames. */
export const homeFeatureShowcaseVisualScopeClass = [
  "[&_.hero-slide-shell]:!h-full [&_.hero-slide-shell]:!min-h-0",
  "[&_.hero-slide-shell]:!rounded-none [&_.hero-slide-shell]:!border-0 [&_.hero-slide-shell]:!shadow-none",
  "[&_.hero-slide-shell>div:first-child]:!rounded-none",
  "[&_[data-mockup-scene]]:!h-full [&_[data-mockup-scene]]:!min-h-0",
  "[&_[data-mockup-scene]]:!rounded-none [&_[data-mockup-scene]]:!border-0 [&_[data-mockup-scene]]:!shadow-none",
].join(" ");

export const HOME_FEATURE_SHOWCASE_ORDER: HomeMarketingFeatureSlug[] = [
  "write",
  "breakdown",
  "coverage",
  "schedule",
  "budget",
  "collaborate",
];

const HOME_FEATURE_SHOWCASE_ROUTE_SLUGS: Partial<
  Record<HomeMarketingFeatureSlug, FeatureSlug>
> = {
  write: "script",
  schedule: "schedule",
  budget: "budgeting",
};

export const getHomeFeatureShowcaseHref = (
  featureId: HomeMarketingFeatureSlug,
): string => {
  const routeSlug = HOME_FEATURE_SHOWCASE_ROUTE_SLUGS[featureId];
  if (routeSlug) {
    return `/features/${routeSlug}`;
  }
  return "/features";
};
